import { render, staticRenderFns } from "./activeChatLog.vue?vue&type=template&id=9363072a&scoped=true&"
import script from "./activeChatLog.vue?vue&type=script&lang=js&"
export * from "./activeChatLog.vue?vue&type=script&lang=js&"
import style0 from "./activeChatLog.vue?vue&type=style&index=0&id=9363072a&prod&lang=scss&"
import style1 from "./activeChatLog.vue?vue&type=style&index=1&id=9363072a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9363072a",
  null
  
)

export default component.exports